import { Router } from 'vue-router';
import AuthService from '../../services/AuthService';
import { routeIsPublic, setInitialRoute } from '../util';

export default function setupAuthenticationGuard(router: Router): void {
  router.beforeEach(async (to, from, next) => {
    const isAuthenticated = AuthService.isAuthenticated();

    if (!routeIsPublic(to) && !isAuthenticated) {
      setInitialRoute(to.fullPath);
      return next({ name: 'login' });
    }

    if (to.name === 'login' && isAuthenticated) {
      return next(from.fullPath);
    }

    return next();
  });
}
